import { render } from "./BaseGroup.vue?vue&type=template&id=1e671bb4&scoped=true&lang=pug"
import script from "./BaseGroup.vue?vue&type=script&lang=js"
export * from "./BaseGroup.vue?vue&type=script&lang=js"

import "./BaseGroup.vue?vue&type=style&index=0&id=1e671bb4&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e671bb4"]])

export default __exports__